/**
 * "API keys" — Auth section (ADR-0074).
 * Reconciled from api-key.graphql (secret `gak_` vs publishable `pk_`, once-only
 * reveal, revoke) + the ApiKeysPage dashboard feature.
 */
import type { DocPageContent } from '../types';

const KEY_FORMATS = `gak_<env>_<32 base32 chars>   # secret — CLI / MCP, server-side only
pk_<test|live>_<32 base32 chars>  # publishable — embedded in your page`;

export const AUTH_API_KEYS_PAGE: DocPageContent = {
  slug: 'auth/api-keys',
  titleKey: 'docs.auth.keys.title',
  descriptionKey: 'docs.auth.keys.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.auth.keys.lead' },

    { kind: 'heading', level: 2, id: 'kinds', textKey: 'docs.auth.keys.kinds.heading' },
    {
      kind: 'definitions',
      items: [
        { termKey: 'docs.auth.keys.kind.secret.term', descKey: 'docs.auth.keys.kind.secret.desc' },
        {
          termKey: 'docs.auth.keys.kind.publishable.term',
          descKey: 'docs.auth.keys.kind.publishable.desc',
        },
      ],
    },
    { kind: 'code', language: 'text', code: KEY_FORMATS },

    { kind: 'heading', level: 2, id: 'creating', textKey: 'docs.auth.keys.creating.heading' },
    { kind: 'paragraph', textKey: 'docs.auth.keys.creating.body' },
    {
      kind: 'steps',
      steps: [
        { titleKey: 'docs.auth.keys.step.open.title', textKey: 'docs.auth.keys.step.open.text' },
        {
          titleKey: 'docs.auth.keys.step.choose.title',
          textKey: 'docs.auth.keys.step.choose.text',
        },
        { titleKey: 'docs.auth.keys.step.copy.title', textKey: 'docs.auth.keys.step.copy.text' },
      ],
    },
    {
      kind: 'callout',
      tone: 'caution',
      titleKey: 'docs.auth.keys.once.title',
      textKey: 'docs.auth.keys.once.body',
    },

    { kind: 'heading', level: 2, id: 'environments', textKey: 'docs.auth.keys.envs.heading' },
    { kind: 'paragraph', textKey: 'docs.auth.keys.envs.body' },

    { kind: 'heading', level: 2, id: 'revoking', textKey: 'docs.auth.keys.revoking.heading' },
    { kind: 'paragraph', textKey: 'docs.auth.keys.revoking.body' },

    { kind: 'heading', level: 2, id: 'safety', textKey: 'docs.auth.keys.safety.heading' },
    {
      kind: 'list',
      itemKeys: [
        'docs.auth.keys.safety.secret',
        'docs.auth.keys.safety.publishable',
        'docs.auth.keys.safety.rotate',
        'docs.auth.keys.safety.audit',
      ],
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.auth.keys.next.cli.title',
          textKey: 'docs.auth.keys.next.cli.text',
          to: { docSlug: 'cli/init' },
        },
        {
          titleKey: 'docs.auth.keys.next.widget.title',
          textKey: 'docs.auth.keys.next.widget.text',
          to: { docSlug: 'widget/configuration' },
        },
      ],
    },
  ],
};
